import { useState, useEffect } from 'react';
import NaviBar from '../NaviBar/NaviBar';
import SearchBar from '../NaviBar/SearchBar';
import Cookies from 'js-cookie';
import noimg from '../../Icons/noimg.jpg';
import { Modal } from 'react-bootstrap';
import { currencyStyle } from '../../services/methods';
import { currencyOptions } from '../../staticData/options';
import addIcon from '../../Icons/add-quantity-icon.svg';
import decreIcon from '../../Icons/decrease-qtt.svg';
import 'animate.css';
import BottomCard from '../ShoppingCart/BottomCart';
import ProductCard from '../homeProduct/ProductCard';
import BrandCard2 from '../homeProduct/BrandCard2';
import { useTranslation } from 'react-i18next';

function CategoryPage(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { t } = useTranslation();
  const {
    productss,
    cleanUp,
    setLoading,
    cart,
    add,
    decreStock,
    changeProdPrice,
    alterquantity,
    itemCounter,
    langs,
    remove,
    setShowCart,
    showCart,
    brandOrCate,
    catename,
    id,
    setlangs,
    stat,
    setStat,
    changePrice,
    promoRef,
    audio,
    stopPlay,
    HFuser,
    setClientUser,
    clientUser,
  } = props;

  const currentCate = JSON.parse(localStorage.getItem('currentCate'))
    ? JSON.parse(localStorage.getItem('currentCate'))
    : null;
  // console.log('currentCate', currentCate);
  let Fname = 'Products';
  if (currentCate?.name) {
    Fname =
      currentCate.name[langs] && currentCate.name[langs] !== ''
        ? currentCate.name[langs]
        : currentCate.name?.en;
  }

  const imageOnError = (ev) => {
    ev.target.src = noimg;
  };

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    } else if (mycoockie === 'zh') {
      setMainL('zh-CN');
    }
  }, []);

  const [mainL, setMainL] = useState('en-US');
  const [showp, setShowp] = useState(false);
  const [showLabelFilter, setShowLabelFilter] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [selectedLabels, setSelectedLabels] = useState([]);

  const machine = JSON.parse(localStorage.getItem('machine'));
  const use_allergy_mode = machine?.themeColor?.use_allergy_mode === 'true';
  const excludeMode = use_allergy_mode;

  console.log('use_allergy_mode', use_allergy_mode);

  let imageUrl = '';

  const enable_label = machine?.themeColor?.enable_label_feature === 'true';
  const allProductImage = machine.themeColor?.allProduct
    ? isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor?.allProduct}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor?.allProduct}/${machine.belongTo}`
    : noimg;

  const symbol = machine?.currency?.symbol || '$';
  let result = JSON.parse(localStorage.getItem('products'));

  // Extract unique labels from products
  const extractUniqueLabels = (products) => {
    const labelMap = new Map();
    products.forEach((product) => {
      if (product.labels && Array.isArray(product.labels)) {
        product.labels.forEach((labelObj) => {
          if (labelObj._id && labelObj.name) {
            labelMap.set(labelObj._id, labelObj);
          }
        });
      }
    });
    return Array.from(labelMap.values());
  };

  const uniqueLabels = enable_label ? extractUniqueLabels(result) : [];

  // Filter products based on selected labels
  const filterProductsByLabels = (products, selectedLabelIds, excludeMode) => {
    if (!selectedLabelIds.length) return products;

    return products.filter((product) => {
      if (!product.labels || !Array.isArray(product.labels)) {
        return excludeMode;
      }

      const productLabelIds = product.labels.map((label) => label._id);
      const hasSelectedLabel = selectedLabelIds.some((labelId) =>
        productLabelIds.includes(labelId)
      );
      return excludeMode ? !hasSelectedLabel : hasSelectedLabel;
    });
  };

  let brands = JSON.parse(localStorage.getItem('brand'))
    ? JSON.parse(localStorage.getItem('brand'))
    : [];

  if (catename === 'bestSellers') {
    Fname = 'Machine Products';
    result = result.filter((product) => product.prodType === 'prod');
  } else if (catename === 'fridge1') {
    Fname = 'Fridge Products';
    result = result.filter((product) => product.prodType === 'fridge1');
  } else if (catename === 'fridge2') {
    Fname = 'Shelf Products';
    result = result.filter((product) => product.prodType === 'fridge2');
  } else if (catename === 'fridge3') {
    Fname = 'Locker Products';
    result = result.filter((product) => product.prodType === 'linkedBox' && !product.isSold);
  } else {
    if (catename !== 'all' && catename !== 'allBrand') {
      console.log('catename', catename);
      if (brandOrCate === 'brand') {
        // imageUrl = `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.picture}/${currentCate.referTo}`;
        imageUrl = isLocal
          ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${currentCate.picture}`
          : `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.picture}/${currentCate.referTo}`;
        result = result.filter((product) => product.brand?._id === id);
      } else if (brandOrCate === 'cate') {
        // imageUrl = `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.categoryPicture}/${currentCate.referTo}`;
        imageUrl = isLocal
          ? `${process.env.REACT_APP_LOCAL_API}/pictures/category/${currentCate.categoryPicture}`
          : `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.categoryPicture}/${currentCate.referTo}`;
        result = result.filter((product) => product.category.includes(id));
      }
    } else {
      imageUrl = allProductImage;
    }
  }

  // Apply label filtering
  if (enable_label && selectedLabels.length > 0) {
    result = filterProductsByLabels(result, selectedLabels, excludeMode);
  }

  //
  useEffect(() => {
    if (catename === 'allBrand') {
      stat.all_brand = stat.all_brand += 1;
    } else if (catename === 'all') {
      stat.all_prod = stat.all_prod += 1;
    } else {
      if (brandOrCate === 'cate') {
        const index = stat?.cate.findIndex((item) => item._id === id);
        if (index >= 0) {
          stat.cate[index].detail = stat.cate[index].detail += 1;
        } else {
          stat.cate.push({
            _id: id,
            detail: 1,
            name: currentCate?.name?.en || 'Unknown Category',
          });
        }
      }
      if (brandOrCate === 'brand') {
        const index = stat?.brand.findIndex((item) => item._id === id);
        if (index >= 0) {
          stat.brand[index].detail = stat.brand[index].detail += 1;
        } else {
          stat.brand.push({
            _id: id,
            detail: 1,
            name: currentCate?.name?.en || 'Unknown Brand',
          });
        }
      }
    }
    setStat(stat);
  }, []);

  // Define a common sorting function
  function sortByName(arr, langs) {
    return arr?.sort((a, b) => {
      const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
      const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  if (catename === 'allBrand') {
    if (machine.themeColor?.sp_column === '1') {
    } else {
      brands = sortByName(brands, langs);
    }
  } else {
    if (machine.themeColor?.sp_column === '1') {
    } else {
      result = sortByName(result, langs);
    }
  }
  console.log('result', result);

  // Label filter handlers
  const toggleLabelFilter = () => {
    if (showLabelFilter) {
      setIsClosing(true);
      setTimeout(() => {
        setShowLabelFilter(false);
        setIsClosing(false);
      }, 300); // 匹配动画时长
    } else {
      setShowLabelFilter(true);
    }
  };

  const toggleLabelSelection = (labelId) => {
    setSelectedLabels((prev) =>
      prev.includes(labelId) ? prev.filter((id) => id !== labelId) : [...prev, labelId]
    );
  };

  const clearAllLabels = () => {
    setSelectedLabels([]);
  };

  // Get label name based on current language
  const getLabelName = (label) => {
    return label.name[langs] && label.name[langs] !== '' ? label.name[langs] : label.name.en;
  };
  const products =
    catename === 'allBrand'
      ? brands.map((brand) => {
          // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${brand.picture}/${brand.referTo}`;
          let url = isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${brand.picture}`
            : `${process.env.REACT_APP_SERVER_API}/pictures/${brand.picture}/${brand.referTo}`;
          return <BrandCard2 key={brand._id} langs={langs} prod={brand} image={url} />;
        })
      : result.map((prod) => {
          // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
          let url = isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.productPictures[0]}`
            : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;

          if (prod.prodType === 'fridge1' || prod.prodType === 'fridge2') {
            url = isLocal
              ? `${process.env.REACT_APP_LOCAL_API}/pictures/fridge/${prod.productPictures[0]}`
              : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
          }
          if (prod.prodType === 'linkedBox') {
            url = isLocal
              ? `${process.env.REACT_APP_LOCAL_API}/pictures/linkedBoxProduct/${prod.productPictures[0]}`
              : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
          }
          return (
            <ProductCard
              twoLine={true}
              langs={props.langs}
              mainL={mainL}
              symbol={symbol}
              setShowp={setShowp}
              cart={props.cart}
              alterquantity={props.alterquantity}
              add={props.add}
              key={prod.uid ? prod.uid : prod._id}
              remove={remove}
              decreStock={props.decreStock}
              price={prod.price}
              id={prod._id}
              prod={prod}
              products={props.products}
              i={prod.idx}
              name={prod.name}
              buyX={prod.buyX}
              percentage={prod.percentage}
              discountedPrice={prod.discountedPrice}
              amount={prod.discount}
              image={url}
            />
          );
        });

  return (
    <div className="main-container">
      <div className="Navi"></div>
      <NaviBar
        products={productss}
        cleanUp={cleanUp}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        setShowCart={setShowCart}
        setlangs={setlangs}
        cart={cart}
        langs={langs}
        setLoading={setLoading}
        clientUser={clientUser}
        setClientUser={setClientUser}
      />
      <SearchBar langs={langs} />
      {machine?.themeColor?.hide_category_banner !== 'true' && (
        <img className="cate-banner-img" src={imageUrl} onError={imageOnError} alt=""></img>
      )}

      <div className="cate-page-container">
        <div className="homeProductText" style={{ marginTop: '44px' }}>
          {catename === 'all'
            ? t(`All Products`)
            : catename === 'allBrand'
            ? t('All Brands')
            : Fname}
        </div>
        {currentCate?.limit && catename !== 'all' && catename !== 'all' ? (
          <div className="homeProductText" style={{ fontSize: '40px' }}>
            {`Limit: ${currentCate?.limit}`}
          </div>
        ) : null}

        {/* Label Filter Component */}
        {enable_label && uniqueLabels.length > 0 && catename !== 'allBrand' && (
          <div className="label-filter-container">
            <button onClick={toggleLabelFilter} className="label-filter-button">
              <span>
                {t('Filter')} ({selectedLabels.length})
              </span>
              <span className={`label-filter-arrow ${showLabelFilter ? 'rotated' : ''}`}>▼</span>
            </button>

            {(showLabelFilter || isClosing) && (
              <div className={`label-filter-content ${isClosing ? 'closing' : ''}`}>
                <div className="label-filter-labels">
                  <button onClick={clearAllLabels} className="label-filter-clear-button">
                    {t('Clear All')}
                  </button>
                  {uniqueLabels.map((label) => (
                    <label
                      key={label._id}
                      className={`label-filter-item ${
                        selectedLabels.includes(label._id) ? 'selected' : ''
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={selectedLabels.includes(label._id)}
                        onChange={() => toggleLabelSelection(label._id)}
                        className="label-filter-checkbox"
                      />
                      <span>{getLabelName(label)}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        <div className="cate-products-container">{products}</div>
      </div>
      <BottomCard
        cleanUp={cleanUp}
        setClientUser={setClientUser}
        clientUser={clientUser}
        HFuser={HFuser}
        promoRef={promoRef}
        changePrice={changePrice}
        isLocal={isLocal}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        prods={result}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
        audio={audio}
        stopPlay={stopPlay}
      />
      {showCart && <div></div>}
    </div>
  );
}
export default CategoryPage;
